import { forwardRef } from "react";
import { useRHFAdapter } from "./useRHFAdapter";
import { FieldBaseProps, useFieldProps } from "./useFieldProps";

export type Props = FieldBaseProps & {
  name: string;
  image: string;
  label: string;
};

export const ForceYesInput = forwardRef<HTMLInputElement, Props>(
  (
    { name, image, label, className, isLoading, isSubmitting, error, required },
    ref
  ) => {
    const { inputProps } = useRHFAdapter({
      name,
      setValueAs: (val) => val === "true",
    });

    const fieldProps = useFieldProps({
      className,
      error,
      isLoading,
      isSubmitting,
      required,
    });

    return (
      <div className="flex flex-col gap-8 text-center">
        {/* Hidden input that always returns boolean true */}
        <input
          type="checkbox"
          name={name}
          value="true"
          defaultChecked
          hidden
          {...inputProps}
          ref={(el) => {
            inputProps.ref(el);
            if (typeof ref === "function") ref(el);
          }}
          {...fieldProps}
        />
      </div>
    );
  }
);

ForceYesInput.displayName = "ForceYesInput";

export default ForceYesInput;
